import { createTheme } from '@mui/material/styles'
import darkTheme from './darkTheme'

const applyTheme = (direction = 'ltr') => {
  return createTheme({ ...darkTheme, direction })
}

export { applyTheme }
